export default {
  addDeleteUser: 'add-delete-user',
  addUser: 'add-user',
  deleteUser: 'delete-user',
  everyLogin: 'every-login',
  manual: 'manual',
  nextLogin: 'next-login',
  nextRegistration: 'registration-trigger',
  oneTime: 'one-time',
  repeated: 'repeated',
  trigger: 'trigger',
};
